import React from 'react'
import '../App.css';
import comentarios01 from '../Fotos/comentarios/06.png'
import comentarios02 from '../Fotos/comentarios/05.png'
import comentarios03 from '../Fotos/comentarios/01.png'
import comentarios04 from '../Fotos/comentarios/08.png'
import comentarios05 from '../Fotos/comentarios/07.png'
import comentarios06 from '../Fotos/comentarios/03.png'

import tripadviser from '../Fotos/Logos/tripadvisor.svg'
import imagen04 from '../Fotos/PROMOCION110326.jpeg'


export const Comments = () => {
  return (
    <div>

      <section>
        <h6 id="comentarios" className="camuflaje display-4">
          shuttle
        </h6>

        <h2 className="title-secondary espaciados col-12 text-center text-uppercase display-4 shadow-title mb-5">
          comments
        </h2>

        {/* <img src={imagen04} alt={"promo"} className='mt-3 img-fluid'  />             */}
       

      <p class="camuflaje-home display-4">
        hola
      </p>

        

        <section id="comentarios-ingles">

          <div className="mb-3">

            <h3 style={{fontWeight:"500"}} className="title-secondary text-right mb-3">
              By far one of the Best Companies!!!!
            </h3>

            <div className="row">
              <img src={comentarios01} alt="comentario 06" className="col-lg-6" />

              <p className="text-justify alig col-lg-6">
                We arrived at the airport (PV) retrieved our luggage and walked right outside to our Driver Luis
                Luis directed us to go sit in the van and enjoy a nice cold beer “(or maybe you prefer Tequila)” while he
                packed
                up all our luggage Luis was exceptionally polite and spoke to us all the way to our destination about 45
                minutes
                (Speaks English very well) He even made a pit stop so we could get some more beers!!!
                A couple of days later:
                We decided to take a tour around many of the beautiful beaches in the area and called Quality Transfer PV
                BUT
                we
                made sure we asked for Luis
                Luis arrived the following morning right on time and he made it very clear that wherever we wanted to stop
                we
                could stop!!!
                First stop: Starbucks Lol
                Luis proceeded to take us to the many beaches in the surrounding area giving us the history of each one
                along
                the
                way!
                We stopped at one of his favourite taco places said it was the best around and truthful I’m keto so tacos
                are
                not
                up my alley but I tried them and man they were delicious❤️ Glad I broke my fast for them
                Initially we were suppose to take a tour over to an island from Rincon De Guayabitos beach but the wether
                really
                wasn’t very nice for snorkelling or taking a boat across so our group decided to stay at the beach and have
                a
                few
                drinks
                Luis then suggested we walk through the town to experience some of the local fare!!!
                After a bit Luis suggested a dinner place and we were seated immediately The dinner and drinks were amazing
                The
                name escapes me but Luis will know of the restaurant in Rincon De Guayabitos where he took those crazy
                Canadians
                Lol (Gene Sherry Paulo and Lynn)
                Overall Luis is a very cordial attentive courteous young man You can tell he really likes his job and of
                course
                meeting new people
                Thank you Luis you really are the Best !!!
                We shall see you next year
                Gracias

                Lynn and Paulo Kale
              </p>
            </div>

            <a
              href="https://www.tripadvisor.ca/ShowUserReviews-g150793-d17582509-r743614009-Quality_Transfers_PV-Puerto_Vallarta.html"><img
                src={tripadviser} className="iconos mt-3" alt="tripadvisor" /></a>

          </div>

          <div className="mb-3">

            <h3 style={{fontWeight:"500"}} className="title-secondary text-right mb-3">
              Day trip
            </h3>

            <div className="row">

              <img src={comentarios02} alt="comentario 05" className="col-lg-6" />


              <p className="text-justify alig col-lg-6">
                Luis remembered us when he picked us up at the airport.He is a very cautious driver, had drinks for us and
                we
                were very safe with him.He speaks perfect English.We arranged a day trip and he took us out to several
                beautiful
                locations including a snorkeling beach, an inland waterfall where the Predator was filmed, a visit to see
                crocodiles, a drive up the mountain with history and cultural information along the way.He is a great tour
                guide.
                We were gone 11 hours and he never had to stop for gas or for any personal reasons.It was all about our
                pleasures
                and wants.We have beautiful photographs that he took for us.We have no complaints at all.
              </p>

            </div>


            <a
              href="https://www.tripadvisor.ca/ShowUserReviews-g150793-d17582509-r744699016-Quality_Transfers_PV-Puerto_Vallarta.html"><img
                src={tripadviser} className="iconos mt-3" alt="tripadvisor" /></a>

          </div>

          <div className="mb-3">

            <h3 style={{fontWeight:"500"}} className="title-secondary text-right mb-3">
              Family trip of fun in PVR
            </h3>
            <div className="row">
              <img src={comentarios03} alt="comentario 01" className="col-lg-6" />


              <p className="text-justify alig col-lg-6">
                Luis and his van are exceptional!Luis is organized, prompt, so kind and caring.He had a sign waiting for
                us at
                the airport - he was easy to spot in the airport.Luis carried our bags, took us a short walk to his brand
                new
                luxury van.It is beautiful!He offered us water or beer and turned the air conditioning on right away.We
                felt
                safe and comfortable.Luis pointed out sights on the way to our hotel.It was a lovely ride!Luis is great
                for
                day
                trips too!It feels so safe to be picked up at a club at night- to travel to Salulita and other fun places
                with
                him.
              </p>
            </div>


            <a
              href="https://www.tripadvisor.ca/ShowUserReviews-g150793-d17582509-r748947354-Quality_Transfers_PV-Puerto_Vallarta.html"><img
                src={tripadviser} className="iconos mt-3" alt="tripadvisor" /></a>

          </div>

          <div className="mb-3">
            <h3 style={{fontWeight:"500"}} className="title-secondary text-right mb-3">
              Happy camper, excellent service
            </h3>

            <div className="row">
              <img src={comentarios04} alt="comentario 08" className="col-lg-6" />


              <p className="text-justify alig col-lg-6">
                Luis picked us up on time, hired him for a full tour to the mountains, towns and beaches, before drop off
                time
                we’re couple of ours earlier and he took us to eat lunch and shopping.He knows the locals, traditions,
                towns,
                mountains, entertainment and lots beautiful beaches, he would take you wherever you want to go and show you
                around, and most importantly he knows where the best food is served, he can name you almost every restaurant
                in
                town and what kind of food they serve, he took us to eat grilled red snapper with spicy sauce and cooked
                over
                charcoal (pescado zarandeado) in Bucerias, loved it.
                Excellent service, cooler was always full of drinks.You won’t be disappointed, recommend
              </p>
            </div>




            <a
              href="https://www.tripadvisor.ca/ShowUserReviews-g150793-d17582509-r803271042-Quality_Transfers_PV-Puerto_Vallarta.html"><img
                src={tripadviser} className="iconos mt-3" alt="tripadvisor" /></a>
          </div>

          <div className="mb-3">
            <h3 style={{fontWeight:"500"}} className="title-secondary text-right mb-3">
              Best service friendly and great English.
            </h3>
            <div className="row">
              <img src={comentarios05} alt="comentario 07" className="col-lg-6" />


              <p className="text-justify alig col-lg-6">
                Luis is the best driver and tour guide ever, his English is very good and he is extremely knowledgable.
              </p>
            </div>




            <a
              href="https://www.tripadvisor.ca/ShowUserReviews-g150793-d17582509-r743550251-Quality_Transfers_PV-Puerto_Vallarta.html"><img
                src={tripadviser} className="iconos mt-3" alt="tripadvisor" /></a>
          </div>

          <div className="mb-3">
            <h3 style={{fontWeight:"500"}} className="title-secondary text-right mb-3">
              Excellent service
            </h3>

            <div className="row">
              <img src={comentarios06} alt="comentario 03" className="col-lg-6" />


              <p className="text-justify alig col-lg-6">
                I loved being fascinated by his very cordial service from my reservation in the mail, as on arrival when
                seeing
                my
                name on the sign of Quality Transfers PV the driver spoke very good English and knows Puerto Vallarta very
                well.
                We will use them again !! if i recommend them.
              </p>
            </div>




            <a
              href="https://www.tripadvisor.ca/ShowUserReviews-g150793-d17582509-r751702609-Quality_Transfers_PV-Puerto_Vallarta.html"><img
                src={tripadviser} className="iconos mt-3" alt="tripadvisor" /></a>
          </div>


          <div className="mb-3">
            <h3 style={{fontWeight:"500"}} className="title-secondary text-right mb-3">
              Skip the Taxi's. Contact Quality Transfer PV!!
            </h3>




            <p className="text-justify">
              This group is fantastic. Picked us up at our Condo and transported us to the airport. Fast, friendly (drinks
              included if you so desire) assisted with luggage all the way to the ticket counter. Great on local knowledge.
              Will call whenever we get back to PV!!
            </p>

            <a
              href="https://www.tripadvisor.ca/ShowUserReviews-g150793-d17582509-r745699897-Quality_Transfers_PV-Puerto_Vallarta.html"><img
                src={tripadviser} className="iconos mt-3" alt="tripadvisor" /></a>
          </div>






          <div className="mb-3">
            <h3 style={{fontWeight:"500"}} className="title-secondary text-right mb-3">
              10 Star Experience!!!
            </h3>




            <p className="text-justify">
              Luigi picked us up last minute in his beautiful brand new Mercedes Sprinter Van. His English is perfect and he
              even offered us drinks. He also carried 2 of our bags all the way to the check in counter for us. Fantastic
              service and great personality!!! For 5 people going to the airport from Zona Romantica in Puerto Vallarta, the
              price was less expensive than getting a taxi van. We will definitely use his services again and are excited to
              see some of the tours he offers on our next stay!!
            </p>

            <a
              href="https://www.tripadvisor.ca/ShowUserReviews-g150793-d17582509-r745260272-Quality_Transfers_PV-Puerto_Vallarta.html"><img
                src={tripadviser} className="iconos mt-3" alt="tripadvisor" /></a>
          </div>








          <div className="mb-3">
            <h3 style={{fontWeight:"500"}} className="title-secondary text-right mb-3">
              service and quality to the maximum
            </h3>


            <p className="text-justify">
              We had a great experience using this company,they were expecting us with cold water and beer which was much
              appreciated! Our driver very friendly and knowledgeable about the area. I will use your services again !!!
            </p>
            <a
              href="https://www.tripadvisor.ca/ShowUserReviews-g150793-d17582509-r751704189-Quality_Transfers_PV-Puerto_Vallarta.html"><img
                src={tripadviser} className="iconos mt-3" alt="tripadvisor" /></a>
          </div>








          <div className="mb-3">
            <h3 style={{fontWeight:"500"}} className="title-secondary text-right mb-3">
              Experience using the transfer company
            </h3>




            <p className="text-justify">
              We had a great experience using the transfer service. The driver told us about the history of PV and made the
              ride
              very enjoyable. The van was roomy and new. Would recommend this company to anyone.
            </p>

            <a
              href="https://www.tripadvisor.ca/ShowUserReviews-g150793-d17582509-r744892656-Quality_Transfers_PV-Puerto_Vallarta.html"><img
                src={tripadviser} className="iconos mt-3" alt="tripadvisor" /></a>
          </div>










          <div className="mb-3">
            <h3 style={{fontWeight:"500"}} className="title-secondary text-right mb-3">
              Friendly service
            </h3>


            <p className="text-justify">
              Our driver Luis was friendly and always on time. Will be using their services again. He was knowledgeable
              about
              the area and offered refreshments during our ride.
            </p>
            <a href="https://www.tripadvisor.ca/Profile/Boissc1"><img src={tripadviser}
              className="iconos mt-3" alt="tripadvisor" /></a>
          </div>







        </section>



      </section>
    </div>
  )
}
